import { Injectable } from '@angular/core';
import { TableColumn } from '../table-column';
import { TableFilter } from './table-filter';

@Injectable({
  providedIn: 'root',
})
export class TableFilterService {
  public createFilters(eventFilters: any, columns: TableColumn[]): TableFilter[] {
    const filters = columns
      .map(x => {
        const colFilter = eventFilters[x.valueField];
        if (colFilter) {
          const filter = new TableFilter();
          filter.propertyName = x.valueField;
          filter.stringValue = colFilter.value;
          filter.filterType = x.filterType;
          return filter;
        }
      })
      .filter(x => !!x);

    return filters && filters.length > 0 ? filters : null;
  }
}
